namespace $ {
	/** Git history for the entire skill catalogue; token stays in private profile settings. */
	export class $shm_hitalama_skills_github extends $shm_hitalama_components_github {
		override async read( repository: string, token: string, revision = 0 ) {
			const remote = await super.read( repository, token, revision )
			if( remote.private !== true ) throw new Error( 'Репозиторий скиллов должен быть закрытым. Измените его видимость на GitHub или укажите другой репозиторий.' )
			return remote
		}
		static package_path( path: string ) {
			this.$.$shm_hitalama_skills_yaml.path( path )
			const [ name, ...parts ] = path.split( '/' )
			if( !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test( name ) || name.length > 64 || !parts.length || /[<>:"|?*]/.test( path ) || path.split( '/' ).some( part => /[. ]$/.test( part ) || /^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\.|$)/i.test( part ) ) ) throw new Error( 'Некорректный путь файла скилла: ' + path )
			return path
		}
		static catalogue_files( catalog: $shm_hitalama_skills_catalog ) {
			const entries = [...catalog.entries()].sort( ( a, b )=> a.link().str < b.link().str ? -1 : a.link().str > b.link().str ? 1 : 0 )
			const files: Record<string, string> = {}, names = new Set<string>(), paths = new Set<string>()
			for( const entry of entries ) {
				if( entry.group() ) continue
				const name = entry.metadata().name
				if( names.has( name ) ) throw new Error( 'Повторяющееся имя скилла: ' + name )
				names.add( name )
				for( const path of [...entry.paths()].sort() ) {
					// Cleared CRDT dictionary keys remain present after file_remove().
					if( path !== 'SKILL.md' && !entry.file( path ) ) continue
					const target = this.package_path( name + '/' + path ), folded = target.toLowerCase()
					if( paths.has( folded ) ) throw new Error( 'Пути файлов отличаются только регистром: ' + target )
					paths.add( folded ); files[ target ] = entry.file_text( path )
				}
			}
			const tree = catalog.tree()
			files[ '.hitalama.json' ] = JSON.stringify({ format: 1, kind: 'skills', catalog: catalog.link().str,
				entries: entries.map( entry => ({ id: entry.link().str, title: entry.title(), group: entry.group(), name: entry.group() ? '' : entry.name(), parent: entry.Parent()?.val() ?? '' }) ),
				order: [ { parent: '', children: tree.roots }, ...entries.filter( entry => entry.group() ).map( entry => ({ parent: entry.link().str, children: tree.children( entry.link().str ) }) ) ],
				files: Object.keys( files ).sort(),
			}, null, '\t' ) + '\n'
			return files
		}
		override commit_message( files: Record<string, string> ) { return 'Update skills catalogue' }
		override async changes( repository: string, token: string, snapshot: string, remote: $shm_hitalama_components_github_state | null ) {
			const files = JSON.parse( snapshot ) as Record<string, string>, manifest = JSON.parse( files[ '.hitalama.json' ] )
			if( manifest.kind !== 'skills' || manifest.format !== 1 ) throw new Error( 'Некорректный снимок каталога скиллов.' )
			const hashes = await this.hashes( snapshot )
			const changed = Object.keys( hashes ).filter( path => hashes[ path ] !== remote?.files[ path ] ), removed: string[] = []
			if( remote?.files[ '.hitalama.json' ] ) {
				const previous = await this.metadata( repository, token, remote.files[ '.hitalama.json' ] )
				if( previous.kind !== 'skills' || previous.format !== 1 || previous.catalog !== manifest.catalog || !Array.isArray( previous.files ) || !Array.isArray( previous.entries ) ) throw new Error( 'Репозиторий принадлежит другому каталогу или содержит неизвестный формат.' )
				const skills = new Set<string>()
				for( const entry of previous.entries ) if( entry.group === false ) { this.$.$shm_hitalama_skills_github.package_path( entry.name + '/SKILL.md' ); skills.add( entry.name ) }
				for( const path of previous.files ) {
					if( typeof path !== 'string' ) throw new Error( 'Некорректный список файлов скиллов.' )
					this.$.$shm_hitalama_skills_github.package_path( path )
					if( !skills.has( path.split( '/' )[0] ) ) throw new Error( 'Путь не принадлежит скиллам из манифеста.' )
					if( !( path in files ) && path in remote.files ) removed.push( path )
				}
			}
			return { changed, removed: [...new Set( removed )].sort() }
		}
	}
}
